import React, { FC, ReactElement } from "react";

import { JsonLdContainerProps } from "~/bff/components/JsonLdContainer";

export const SeoJsonLd: FC<JsonLdContainerProps> = ({ items }) => {
  return <>{items as ReactElement[]}</>;
};
